var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,93.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253 572 c-81 -3 -84 -5 -48 -34 24 -19 43 -20 233 -23 114 -1 228 -6 255 -10 60 -9 65 12 10 47 -39 23 -195 30 -450 20z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,93.000000) scale(0.100000,-0.100000)",
    fill: "#D6E4F5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420 615 c16 -19 15 -20 -40 -31 -38 -8 -30 -9 60 -9 96 0 101 1 57 10 -45 10 -47 11 -30 28 16 16 15 17 -21 17 -33 0 -37 -2 -26 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615 579 c-16 -8 -15 -8 10 -5 36 5 115 -36 115 -60 0 -13 -8 -15 -47 -9 -27 4 -141 9 -255 10 -190 3 -209 4 -233 23 -36 29 -33 31 48 35 72 3 72 3 -5 5 -68 2 -78 0 -78 -15 0 -44 52 -55 270 -58 113 -1 229 -6 258 -10 72 -10 75 21 5 65 -50 32 -57 34 -88 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 444 c3 -8 7 -77 8 -152 2 -135 2 -136 7 -42 6 92 21 105 21 18 0 -33 3 -39 16 -34 9 4 23 1 30 -5 11 -9 14 -8 14 2 0 11 2 11 10 -1 13 -20 13 -43 0 -35 -5 3 -10 -3 -10 -15 0 -12 4 -18 11 -15 6 4 10 1 8 -6 -5 -42 2 -71 16 -65 8 3 15 1 15 -4 0 -6 10 -11 23 -12 12 0 2 -4 -23 -8 -39 -6 -36 -7 30 -8 45 0 65 3 50 7 -25 7 -25 7 8 21 25 12 32 21 32 42 0 35 -17 37 -26 3 -3 -14 -10 -25 -15 -25 -5 0 -9 11 -9 25 0 26 -15 34 -23 13 -3 -7 -6 -3 -6 10 -1 13 -6 32 -11 42 -8 15 -6 21 7 29 10 5 14 13 9 18 -5 4 -11 2 -13 -4 -6 -18 -23 -16 -23 2 0 17 65 22 75 5 17 -27 35 -8 37 38 1 26 5 -7 8 -73 6 -120 6 -120 8 18 1 94 5 136 13 132 7 -5 9 9 7 42 -3 48 -3 48 -157 51 -137 2 -153 1 -147 -14z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,93.000000) scale(0.100000,-0.100000)",
    fill: "#2F7ED2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569 811 c-13 -11 -21 -23 -16 -27 9 -9 77 22 77 36 0 17 -36 11 -61 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 610 c-10 -11 -13 -20 -8 -20 6 0 14 7 17 16 5 13 23 15 115 12 60 -2 107 0 104 5 -11 18 -209 8 -228 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 563 c2 -24 2 -24 6 -6 4 21 10 23 111 26 l107 3 -112 2 c-113 2 -113 2 -112 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 502 c-7 -4 18 -6 55 -4 96 5 108 10 27 11 -38 0 -76 -3 -82 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 457 c-2 -7 -3 -98 -1 -202 l2 -190 3 197 2 197 98 4 97 3 -98 2 c-72 1 -99 -1 -103 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618 262 c2 -108 6 -200 10 -204 4 -4 6 82 4 190 -2 108 -6 200 -10 204 -4 4 -6 -82 -4 -190z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 260 c0 -107 2 -151 3 -97 2 53 2 141 0 195 -1 53 -3 9 -3 -98z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,93.000000) scale(0.100000,-0.100000)",
    fill: "#0C254C",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555 847 c-24 -14 -41 -31 -43 -44 -2 -15 -22 -33 -60 -54 -78 -44 -92 -58 -92 -91 0 -28 0 -28 -96 -28 -120 0 -134 -7 -134 -64 0 -41 3 -46 50 -80 28 -20 57 -36 65 -36 12 0 15 -31 17 -198 3 -167 5 -197 18 -197 13 0 16 32 20 205 l5 205 145 1 c80 0 153 -4 163 -8 15 -8 17 -28 17 -203 0 -112 4 -196 9 -200 23 -14 31 42 31 214 0 181 0 181 55 181 49 0 55 2 61 24 24 96 -51 148 -205 144 -73 -2 -106 -7 -109 -15 -3 -10 21 -13 97 -13 121 0 181 -27 181 -81 0 -27 -3 -29 -39 -29 -21 0 -52 7 -67 15 -32 16 -153 19 -309 6 -103 -9 -174 18 -175 67 0 22 2 22 125 22 129 0 136 3 113 40 -18 28 -4 47 62 83 36 21 65 30 90 29 47 -3 120 46 120 81 0 51 -49 61 -115 24z m75 -27 c0 -14 -68 -45 -77 -36 -5 4 3 16 16 27 25 20 61 26 61 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalks);
export default __webpack_public_path__ + "static/media/talks.d20b31218b81a20e40780d99ba377560.svg";
export { ForwardRef as ReactComponent };